import React, { useEffect, useState } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

export default function AtivosDesinstalados() {
  const [dados, setDados]   = useState<any[]>([])
  const [busca, setBusca]   = useState("")
  const [loading, setLoading] = useState(true)

  const carregar = async () => {
    try {
      const r = await axios.get(`${API}/ativos?status_instalacao=desinstalado`)
      setDados(r.data.filter((a:any)=>a.status_instalacao==="desinstalado"||a.status_instalacao==="parcial"))
    } catch {} finally { setLoading(false) }
  }

  useEffect(()=>{ carregar() },[])

  const fmtData = (d:any) => d ? new Date(d).toLocaleDateString("pt-BR") : "—"
  const fmtMoeda = (v:any) => v ? `R$ ${parseFloat(v).toFixed(2).replace(".",",")}` : "—"

  const filtrados = dados.filter(d =>
    !busca || d.nome?.toLowerCase().includes(busca.toLowerCase()) ||
    d.placa?.toLowerCase().includes(busca.toLowerCase())
  )

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}>🔴 Ativos Desinstalados</h2>
          <p style={{fontSize:13,color:"#64748b"}}>{filtrados.length} registro(s)</p>
        </div>
      </div>

      <div style={{marginBottom:16}}>
        <input placeholder="Buscar por nome ou placa..." value={busca}
          onChange={e=>setBusca(e.target.value)} style={{maxWidth:400}} />
      </div>

      <div className="card" style={{padding:0,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{background:"#0d1b2e"}}>
              {["Veículo","Placa","Cliente","Data Instalação","Data Desinstalação","Motivo","Custo Desinstal.","Dias de Uso","Status"].map(h=>(
                <th key={h} style={{padding:"10px 14px",textAlign:"left",fontSize:11,
                  color:"#64748b",fontWeight:600,textTransform:"uppercase",letterSpacing:0.5}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} style={{padding:24,textAlign:"center",color:"#64748b"}}>Carregando...</td></tr>
            ) : filtrados.length === 0 ? (
              <tr><td colSpan={9} style={{padding:24,textAlign:"center",color:"#64748b"}}>Nenhum ativo desinstalado</td></tr>
            ) : filtrados.map((a:any)=>{
              const diasUso = a.data_ativacao && a.data_desinstalacao
                ? Math.ceil((new Date(a.data_desinstalacao).getTime()-new Date(a.data_ativacao).getTime())/(1000*60*60*24))+1
                : null
              return (
                <tr key={a.id} style={{borderBottom:"1px solid rgba(45,65,102,0.4)"}}>
                  <td style={{padding:"10px 14px",fontWeight:600,fontSize:13}}>{a.nome}</td>
                  <td style={{padding:"10px 14px",fontSize:12,fontFamily:"monospace"}}>{a.placa||"—"}</td>
                  <td style={{padding:"10px 14px",fontSize:12,color:"#94a3b8"}}>{a.cliente_nome||"—"}</td>
                  <td style={{padding:"10px 14px",fontSize:12}}>{fmtData(a.data_ativacao)}</td>
                  <td style={{padding:"10px 14px",fontSize:12,color:"#f87171"}}>{fmtData(a.data_desinstalacao)}</td>
                  <td style={{padding:"10px 14px",fontSize:12,color:"#94a3b8"}}>{a.motivo_desinstalacao||"—"}</td>
                  <td style={{padding:"10px 14px",fontSize:12,color:"#f59e0b",fontWeight:600}}>{fmtMoeda(a.custo_desinstalacao)}</td>
                  <td style={{padding:"10px 14px",fontSize:12,color:"#0ea5e9"}}>
                    {diasUso ? `${diasUso} dias` : "—"}
                  </td>
                  <td style={{padding:"10px 14px"}}>
                    <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,
                      background:a.status_instalacao==="parcial"?"#451a03":"#450a0a",
                      color:a.status_instalacao==="parcial"?"#fbbf24":"#f87171",
                      border:`1px solid ${a.status_instalacao==="parcial"?"#f59e0b":"#dc2626"}`}}>
                      {a.status_instalacao==="parcial"?"⚠️ Parcial":"🔴 Desinstalado"}
                    </span>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
